<template>
  <div class="left-area">
    <div class="pages-wrapper">
      <div class="info" v-if="isPriceTag">
        <!-- 
          价签模板状态：默认四个价格场景
          分别是原价 会员价  促销价  特价（该价格作为定制模板预留，常规情况下是三个价格场景）
        -->
        {{
          `${$t("lcd.Editor.Price Scenario")}（${
            state.programInfo.pages.length
          }${$t("lcd.Editor.Price Scenario Nums")}）`
        }}
      </div>
      <div class="info" v-if="!isPriceTag && !isEslPriceTag">
        <!-- 营销模板状态-->
        {{ `Maximum(${state.programInfo.itemQty} Items)` }}
      </div>
      <div class="pages">
        <div
          v-for="(page, idx) in state.programInfo.pages"
          :key="idx"
          class="page"
          :class="[{ active: idx === state.currentPageIdx }]"
          @click="handleSelectPage(idx)"
        >
          <div class="idx">{{ idx + 1 }}</div>
          <div class="btns-wrapper">
            <div
              class="btn-wrapper"
              :title="$t('button.Copy')"
              style="padding: 3px 0; cursor: pointer"
              @click.stop="handleCopy(idx)"
            >
              <!-- <tumeng-svg-icon class="copy" icon-class="copy" /> -->
              <span
                class="add icon iconfont"
                style="font-size: 16px; line-height: 16px"
                >&#xe8b0;
              </span>
            </div>
            <div
              class="btn-wrapper"
              :title="$t('lcd.Editor.Paste')"
              style="padding: 3px 0; cursor: pointer"
              @click.stop="handlePaste(idx)"
            >
              <span
                class="add icon iconfont"
                style="font-size: 16px; line-height: 16px"
                >&#xe687;
              </span>
              <!-- <tumeng-svg-icon class="add" icon-class="paste" /> -->
            </div>
            <!-- <div class="btn-wrapper" title="删除" @click="handleDelete(idx)">
              <tumeng-svg-icon class="delete" icon-class="delete" />
            </div> -->
            <!-- <div class="btn-wrapper" title="编辑" @click.stop="handleEdit(idx)">
              <tumeng-svg-icon class="edit" icon-class="edit" />
            </div> -->
            <!-- <div
              class="btn-wrapper"
              title="新增组件组"
              @click.stop="addNewGroup"
            >
              <tumeng-svg-icon class="add" icon-class="add" />
            </div> -->
          </div>
          <div class="info">
            <div class="thumb">
              <div class="container" :style="containerStyle(page)">
                <tumeng-draggable
                  v-for="(component, index) in page.componentList.filter(
                    (it) => !it.hide
                  )"
                  :key="component.componentId"
                  :idx="index"
                  :conf="component"
                  :preview="true"
                >
                  <component :is="component.type" :conf="component" />
                </tumeng-draggable>
              </div>
              <div class="xxx"></div>
            </div>
            <div class="title" v-if="page.title == 'Price1'">
              {{ $t("lcd.Template.Price1") }}
            </div>
            <div class="title" v-else-if="page.title == 'Price2'">
              {{ $t("lcd.Template.Price2") }}
            </div>
            <div class="title" v-else-if="page.title == 'Price3'">
              {{ $t("lcd.Template.Price3") }}
            </div>
            <div class="title" v-else-if="page.title == 'Price4'">
              {{ $t("lcd.Template.Price4") }}
            </div>
            <div class="title" v-else-if="page.title == 'Price5'">
              {{ $t("lcd.Template.Price5") }}
            </div>
            <div class="title" v-else>{{page.title}}</div>
          </div>
        </div>
      </div>
      <!-- 不可使用新建场景模板 -->
      <!-- <el-button
        size="small"
        :class="['add-btn', { showAdd: isRender }]"
        @click="handleClickAddPage"
        v-if="false"
      >
        <tumeng-svg-icon icon-class="add" class="add" />
        新建
      </el-button> -->
      <!-- 不可使用模板 -->
      <!-- <el-button
        size="small"
        :class="['template-btn', { showAdd: isRender }]"
        @click="handleClickTemplate"
        v-if="false"
      >
        <tumeng-svg-icon icon-class="template" class="template" />
        模板
      </el-button> -->
    </div>
    <!-- {{ isPriceTag }} -->
    <div class="components">
      <div
        v-for="(it, idx) in componentList"
        :key="idx"
        class="component"
        @click="handleClickComponent(it)"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :content="it.name"
          placement="right"
        >
          <!-- 文本 -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmText'"
            >&#xe649;</span
          >
          <!-- 数字 -->
          <span
            class="icon iconfont icon-shuzi"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmNumber'"
          ></span>
          <!-- 图片 -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmMultiImg'"
            >&#xe6e9;</span
          >
          <!-- 线条组件 -->
          <span
            class="icon iconfont icon-fengexian"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmLine'"
          ></span>
          <!-- 形状色块 -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmBlock'"
            >&#xe702;</span
          >
          <!-- 时间Time -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmTime'"
            >&#xe627;</span
          >
          <!-- 二维码 -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmQRCode'"
            >&#xe7ad;</span
          >
          <!-- 条形码 -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmBarCode'"
            >&#xe952;</span
          >
          <!-- 评级 -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmValuation'"
            >&#xe730;</span
          >
          <!-- 视频 -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmVideo'"
            >&#xe66c;</span
          >
          <!-- 广告位 -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmAd'"
            >&#xe63b;</span
          >
          <!-- 价签 -->
          <span
            class="icon iconfont"
            style="font-size: 16px; color: #606266; line-height: 16px"
            v-if="it.type == 'TmPriceTag'"
            >&#xe618;</span
          >
          <!-- <tumeng-svg-icon :icon-class="it.icon" /> -->
        </el-tooltip>
      </div>
      <!-- <div
        v-if="isPriceTag"
        v-for="(it, idx) in state.componentList1"
        :key="idx"
        class="component"
        @click="handleClickComponent(it)"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :content="it.name"
          placement="right"
        >
          <tumeng-svg-icon :icon-class="it.icon" />
        </el-tooltip>
      </div> -->
    </div>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import {
  attrText,
  attrNumber,
  attrQRCode,
  attrBarCode,
  attrMultiImg,
  attrVideo,
  attrAd,
  attrValuation,
  attrLine,
  attrBlock,
  attrTime,
} from "../../../utils/component-attribute";

import TumengDraggable from "../../tumeng-draggable/src/index.vue";
import TumengText from "../../tumeng-text/src/index.vue";
import TumengNumber from "../../tumeng-number/src/index.vue";
import TumengQRCode from "../../tumeng-qr-code/src/index.vue";
import TumengBlock from "../../tumeng-block/src/index.vue";
import TumengTime from "../../tumeng-time/src/index.vue";
import TumengPriceTag from "../../tumeng-price-tag/src/index.vue";
import TumengBARCode from "../../tumeng-bar-code/src/index.vue";
import TumengMultiImg from "../../tumeng-multi-img/src/index.vue";
import tumengVideo from "../../tumeng-video/src/index.vue";
import tumengAd from "../../tumeng-video/src/index.vue";
import TumengValuation from "../../tumeng-valuation/src/index.vue";

export default {
  name: "LeftArea",
  components: {
    TumengDraggable,
    TumengText,
    TumengNumber,
    TumengQRCode,
    TumengBlock,
    TumengTime,
    TumengPriceTag,
    TumengBARCode,
    TumengMultiImg,
    tumengVideo,
    tumengAd,
    TumengValuation,
  },
  inject: ["getNewComponentId", "getNewPageId", "checkLimitCnt"],
  data() {
    return {
      state: store.state,
      copyPageComponents: {},
    };
  },
  computed: {
    ownProgramData: {
      get() {
        return this.state.programInfo;
      },
      set(val) {
        store.updateProgramInfo(val);
      },
    },
    // 模板类型标志 价签or营销 0是价签  1是营销
    templateFlag() {
      return (store.state.programInfo.templateGroup || 0) == 1;
    },
    isRender() {
      // console.log("0",(store.state.programInfo.templateGroupId || 0) === 0)
      return (store.state.programInfo.templateGroup || 0) === 0;
    },
    isPriceTag() {
      console.log("|||||||>>>>>>>>", store.state.programInfo);
      return store.state.programInfo.templateGroup == 0;
    },
    isEslPriceTag() {
      return store.state.programInfo.templateGroup == 3;
    },
    componentList() {
      return store.state.programInfo.templateGroup == 0
        ? store.state.componentList1
        : store.state.programInfo.templateGroup == 1
        ? store.state.componentList
        : store.state.componentList2;
    },
  },
  methods: {
    containerStyle(page) {
      const scaleX = 143 / this.ownProgramData.width;
      const scaleY = 96 / this.ownProgramData.height;
      let top;
      let left;
      if (scaleX <= 1.0) {
        left = "-" + (this.ownProgramData.width / 2) * (1 - scaleX) + "px";
      } else {
        left = (this.ownProgramData.width / 2) * (scaleX - 1) + "px";
      }
      if (scaleY <= 1.0) {
        top = "-" + (this.ownProgramData.height / 2) * (1 - scaleY) + "px";
      } else {
        top = (this.ownProgramData.height / 2) * (scaleY - 1) + "px";
      }
      const style = {
        position: "absolute",
        width: this.ownProgramData.width + "px",
        height: this.ownProgramData.height + "px",
        background: "#fff",
        transform: `scaleX(${scaleX}) scaleY(${scaleY})`,
        left,
        top,
      };
      if (page.bgColor) {
        style.backgroundColor = page.bgColor;
      }
      if (page.bgImg) {
        style.backgroundImage = `url(${page.bgImg})`;
        style.backgroundSize = "100% 100%";
      }
      return style;
    },

    // 重新选择了另外一页数据
    handleSelectPage(idx) {
      if (this.state.currentPageIdx !== idx) {
        store.updateCurrentPage(idx);
      }
    },

    // 点击添加新页面
    handleClickAddPage() {
      const page = {
        componentList: [],
        title: this.ownProgramData.pages.length + 1 + "品",
        duration: 10,
        bgColor: "#fff",
        imgId: null,
        bgImg: "",
        datasetId: "",
        datasetName: "",
        datasetFields: "",
      };
      page.id = this.getNewPageId();
      store.addPage(page);
      store.updateCurrentPage(store.state.programInfo.pages.length - 1);
    },

    handleClickTemplate() {
      store.updateSelectTemplateDialogVisible(true);
    },
    // 新增组件的组
    addNewGroup() {
      const text = {
        name: "文本",
        type: "TmText",
        icon: "text",
        enabled: true,
      };
      const activeGroup =
        store.state.programInfo.pages[store.state.currentPageIdx].groupNum + 1;
      const other = {
        groupId: activeGroup,
      };
      store.state.showComponentList = activeGroup;
      this.handleClickComponent(text, other);
    },

    // 点击组件按钮触发
    handleClickComponent(it, other) {
      let result;
      switch (it.type) {
        case "TmText":
          this.addTmText(other);
          break;
        case "TmNumber":
          this.addTmNumber(other);
          break;
        case "TmMultiImg":
          this.addImage();
          // store.SET_SELECT_IMG_OPERATION('ADD_COMPONENT')
          // store.updateSelectImgDialogVisible(true)
          break;
        case "TmPriceTag":
          const itemNum =
            store.state.programInfo.pages[store.state.currentPageIdx].itemNum;
          if (itemNum > 0) {
            console.log(
              store.state.programInfo.pages[store.state.currentPageIdx]
                .componentList
            );
            const currentPage =
              store.state.programInfo.pages[store.state.currentPageIdx];
            const currentComponents =
              store.state.programInfo.pages[store.state.currentPageIdx]
                .componentList;
            const currentPriceTagNum = currentComponents.filter(
              (e) => e.type === "TumengPriceTag"
            ).length;
            console.log("currentPriceTagNum", currentPriceTagNum);
            console.log("itemNum", itemNum);
            if (currentPriceTagNum < itemNum) {
              store.SET_SELECT_PRICE_TAG_OPERATION("ADD_COMPONENT");
              store.updateSelectPriceTagDialogVisible(true);
            } else {
              this.$message.warning(
                `该场景最多可绑定${currentPage.itemNum}个商品`
              );
            }
          } else {
            this.$message.warning("该场景无商品可绑定");
          }
          break;
        case "TmLine":
          this.addTmLine();
          break;
        case "TmBlock":
          this.addTmBlock();
          break;
        case "TmTime":
          const nowTime = new Date();
          console.log(nowTime);

          this.addTmTime({ text: nowTime });
          break;
        case "TmQRCode":
          this.addQRCode("0");
          break;
        // store.SET_SELECT_CODE_OPERATION('ADD_COMPONENT')
        // store.updateAddCodeDialogVisible(true)
        // break
        case "TmBarCode":
          this.addQRCode("1");
          break;
        case "TmAppCode":
          this.addQRCode("2");
          break;
        case "TmVideo":
          result = this.checkLimitCnt();
          if (result.videoCount !== 0 || result.adVideoCount !== 0) {
            this.$message.warning("仅支持1个视频组件或1个营销位组件");
          } else {
            this.addVideo();
            // store.SET_SELECT_VIDEO_OPERATION('ADD_COMPONENT')
            // store.updateSelectVideoDialogVisible(true)
          }
          break;
        case "TmAd": // 营销位
          result = this.checkLimitCnt();
          if (result.videoCount !== 0 || result.adVideoCount !== 0) {
            this.$message.warning("仅支持1个视频组件或1个营销位组件");
          } else {
            this.$message.warning("该模板不支持添加营销位");
            // this.addAd();

            // store.updateAddLiveBroadcastDialogVisible(true);
            // store.SET_SELECT_VIDEO_OPERATION('ADD_COMPONENT')
            // store.updateSelectVideoDialogVisible(true)
          }
          break;
        case "TmWebPage":
          store.updateAddWebPageDialogVisible(true);
          break;
        case "TmValuation": // 评级
          this.addValuation();
          break;
        default:
          break;
      }
    },

    // 添加组件
    addComponent(baseAttr) {
      const conf = JSON.parse(JSON.stringify(baseAttr));
      conf.componentId = this.getNewComponentId();
      store.addComponent(conf);
    },

    // 添加文本组件
    addTmText(other) {
      this.addComponent({
        ...attrText,
        ...other,
        width: store.state.programInfo.width,
      });
    },

    // 添加数字组件
    addTmNumber(other) {
      this.addComponent({
        ...attrNumber,
        ...other,
        width: store.state.programInfo.width,
      });
    },
    // 添加线条组件
    addTmLine(other) {
      this.addComponent({ ...attrLine, ...other });
    },
    // 添加色块组件
    addTmBlock(other) {
      this.addComponent({ ...attrBlock, ...other });
    },

    // 添加时间组件
    addTmTime(other) {
      this.addComponent({ ...attrTime, ...other });
    },

    // 添加编码组件
    addQRCode(type) {
      const conf =
        type == 0
          ? JSON.parse(JSON.stringify(attrQRCode))
          : JSON.parse(JSON.stringify(attrBarCode));
      switch (type) {
        case "0":
          conf.title = "QRCode";
          conf.name = "QRCode";
          conf.imgSrc = "/pro/profile/QRCode.jpg";
          conf.type = "TumengQRCode";
          conf.editType = "TumengQRCodeEdit";
          conf.colorFlag = "black";
          break;
        case "1":
          conf.title = "BarCode";
          conf.name = "BarCode";
          conf.imgSrc = "/pro/profile/BarCode.png";
          conf.type = "TumengBARCode";
          conf.editType = "TumengBARCodeEdit";
          conf.colorFlag = "black";
          break;
      }
      conf.imgType = type;
      this.addComponent(conf);
    },

    //图片
    addImage() {
      const conf = JSON.parse(JSON.stringify(attrMultiImg));
      conf.imgList = [
        {
          imgSrc: "/pro/profile/default.jpg",
          imgId: 1,
          imgFormat: "jpg",
          duration: 3,
          width: 200,
          height: 150,
        },
      ];
      this.addComponent(conf);
    },

    //图片
    addVideo() {
      const conf = JSON.parse(JSON.stringify(attrVideo));
      conf.videoList = [
        {
          url: "https://res.bowtz.com/res/lcd/material/video/1763125670879010816/1763125671529127938/20240522/1e503291f48f47e39afaf3cc45582525.mp4",
          videoId: null,
          duration: "7",
        },
      ];
      this.addComponent(conf);
    },

    // 添加营销位
    addAd() {
      const conf = JSON.parse(JSON.stringify(attrAd));
      conf.adList = [
        {
          url: "https://res.bowtz.com/res/lcd/material/video/1763125670879010816/1763125671529127938/20240522/1e503291f48f47e39afaf3cc45582525.mp4",
          videoId: null,
          duration: "7",
        },
      ];
      this.addComponent(conf);
    },

    // 添加评级组件
    addValuation() {
      console.log("添加评级组件");
      this.addComponent(attrValuation);
    },

    // 点击复制按钮触发
    handleCopy(idx) {
      const copyPage = JSON.parse(
        JSON.stringify(this.state.programInfo.pages[idx])
      );
      console.log(copyPage.componentList);
      this.copyPageComponents = copyPage.componentList;
      this.$message.success("复制成功");
      return;
      copyPage.id = this.getNewPageId();
      store.addPage(copyPage);
      store.updateCurrentPage(store.state.programInfo.pages.length - 1);
    },

    handlePaste(idx) {
      console.log(idx);
      console.log("1=====", this.copyPageComponents);
      if (JSON.stringify(this.copyPageComponents) === "{}") {
        this.$message.error("请先复制源模板信息");
        return;
      }
      store.pasteComponents(
        JSON.parse(JSON.stringify(this.copyPageComponents)),
        idx
      );
      this.$message.success("粘贴成功");
    },

    // 点击编辑
    handleEdit(idx) {
      store.updateEditPageDialogVisible(true, idx);
    },

    // 点击删除触发
    handleDelete(idx) {
      if (this.ownProgramData.pages.length < 2) {
        this.$message({
          message: "至少有一个场景",
          type: "warning",
          showClose: true,
        });
      } else {
        this.$confirm("确认要删除当前场景吗", "提示", {})
          .then(() => {
            store.deletePage(idx);
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../assets/style/clearfix";
// 左侧区域
.left-area {
  @include clearfix;
  position: absolute;
  background-color: #fff;
  left: 0;
  top: 48px;
  bottom: 0;
  width: 220px;
  padding-top: 8px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.24), 0 0 6px rgba(0, 0, 0, 0.08);
  .pages-wrapper {
    float: left;
    height: 100%;
    position: relative;
    width: 179px;
    border-right: 1px solid #e7e8f1;
    .add-btn {
      width: 0;
      margin: 8px 4px 0;
      position: absolute;
      bottom: 8px;
      left: 0;
      &.showAdd {
        width: calc(50% - 8px);
      }
    }
    .template-btn {
      width: calc(100% - 8px);
      margin: 8px 4px 0;
      position: absolute;
      bottom: 8px;
      right: 0;
      &.showAdd {
        width: calc(50% - 8px);
      }
    }
    .info {
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
    }
    .pages {
      // height: calc(100% - 88px);
      // 不显示button时不需要-88
      height: calc(100% - 42px);
      overflow: auto;
      .page {
        @include clearfix;
        position: relative;
        width: calc(100% - 12px);
        height: 120px;
        margin: 2px;
        padding: 4px;
        &.active {
          background-color: #e3e7ee;
          .info {
            .thumb {
              border-color: #138fd1;
            }
          }
        }
        &:hover {
          .btns-wrapper {
            display: block;
          }
        }
        .idx,
        .info {
          float: left;
        }
        .idx {
          padding-top: 4px;
          width: 20px;
        }
        .btns-wrapper {
          position: absolute;
          right: 8px;
          top: 8px;
          display: none;
          z-index: 100;
          .delete,
          .copy,
          .edit,
          .add {
            display: block;
            font-size: 18px;
            margin: 4px;
            color: #999;
            cursor: pointer;
            &:hover {
              // background-color: rgba(204,204,204,.6);
              color: #f40;
            }
          }
        }
        .info {
          @include clearfix;
          height: 100%;
          width: calc(100% - 20px);
          box-sizing: border-box;
          .thumb {
            box-sizing: border-box;
            position: relative;
            width: 100%;
            height: 100px;
            background-color: #dcdfe6;
            border: 2px solid transparent;
            // TODO 暂时这么处理
            overflow: hidden;
            .xxx {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
            }
          }
          .title {
            float: left;
            height: 20px;
            line-height: 20px;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            max-width: 100px;
          }
          .duration {
            float: left;
            height: 20px;
            line-height: 20px;
            max-width: 40px;
            margin-left: 7px;
          }
        }
      }
    }
  }
  .components {
    float: left;
    height: 100%;
    width: 40px;
    overflow: auto;
    .component {
      padding: 12px;
      font-size: 16px;
      &:hover {
        background-color: #eee;
      }
    }
  }
}
</style>
